import longLogo from '../assets/logos/long_logo.svg'

export function Header() {
  return (
    <header className="bg-secondary py-2">
      <div className="container mx-auto px-4">
        <nav className="flex justify-between items-center">
          <a href="/" className="h-8">
            <img src={longLogo} alt="Soonish" className="h-full" />
          </a>
          <div className="space-x-4">
            <a href="#features" className="text-foreground hover:text-primary transition-colors">Features</a>
            <a href="#coming-soon" className="text-foreground hover:text-primary transition-colors">Coming Soonish</a>
          </div>
        </nav>
      </div>
    </header>
  )
} 